import { t } from '@lingui/core/macro';
import { SearchInput, Skeleton } from '@pocketlaw/tetris';
import { useComposerData } from '../../../ComposerDataProvider';
export function Search() {
    const { searchQuery, setSearchQuery, loading } = useComposerData();
    const handleChange = (event) => setSearchQuery(event.target.value);
    const handleReset = () => setSearchQuery('');
    return (<Skeleton loading={loading}>
      <SearchInput placeholder={t({
            comment: 'Select template dialog - Search templates placeholder',
            message: 'Search templates',
        })} resetLabel={t({
            comment: 'Select template dialog - Reset search template input label',
            message: 'Clear search',
        })} value={searchQuery} onReset={handleReset} onChange={handleChange}/>
    </Skeleton>);
}
